import React from "react";
import types from "../../data/types";
import swal from "sweetalert";
import {
  Media,
  SelectBlock, Price, Fields,
  Slug, Options, Textarea,
  Input, Form,
} from "../../components/Form/Form";
import {useNavigate, useParams} from "react-router-dom";
import useSpotGroupService from "../../api/services/useSpotGroupService";
import useOptionsService from "../../api/services/useOptionsService";
import ProfileStatusForm from "../../components/Form/ProfileStatusForm";
import Availabilities from "../../components/Form/Availabilities";
import BusinessHour from "../../components/Form/BusinessHour";
import AnchorTitle from "../../components/AnchorMenu/AnchorTitle";
import AnchorIndex from "../../components/AnchorMenu/AnchorIndex";
import EditButton from "../../components/Form/EditButton";
import Checkbox from "../../components/Form/Checkbox";
import Location from "../../components/Form/Location";
import Address from "../../components/Form/Address";
import useForm from "../../hooks/useForm";
import Three from "../../components/Form/Three";
import Bool from "../../components/Form/Bool";
import markedImage from "../../assets/images/example-images/markt.jpg";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";


const UserSpotGroupEdit = () => {
  const optionServiceSpotGroup = useOptionsService('spot_group_option')
  const infoServiceSpotGroup = useOptionsService('spot_group_info')
  const optionServiceStand = useOptionsService('stand_option')
  const infoServiceStand = useOptionsService('stand_info')
  const spotGroupService = useSpotGroupService()
  const navigate = useNavigate()
  const form = useForm();
  const {id} = useParams();

  return (
    <div className="page-user-spot_group-edit">
      <div className="row">
        <div className="col">
          <h1>Locatie Instellingen</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/locatie/{id}/edit"
          />
        </div>
      </div>
      <Form>
        <Fields
          id={id}
          form={form}
          apiService={spotGroupService}
          showDelete={true}
          deleteLabel="Hiermee verwijder je deze locatie:"
          deleteSuccess={() => navigate('/user/locaties')}
          GAEventLabel="User SpotGroup Edit"
        >
          <AnchorIndex
            titles={[
              {
                label: 'Algemeen',
                id: 'general'
              },
              {
                label: 'Profiel',
                id: 'profile'
              },
              {
                label: 'Locatie',
                id: 'location'
              },
              {
                label: 'Afbeeldingen',
                id: 'images'
              },
              {
                label: 'Beschikbaarheid',
                id: 'availabilities'
              },
              {
                label: 'Standplaatsen',
                id: 'spots'
              },
              {
                label: 'Prijs',
                id: 'price'
              },
              {
                label: 'Opties & Info',
                id: 'options'
              },
              {
                label: 'Boekingen',
                id: 'bookings'
              },
            ]}
          />

          <ProfileStatusForm/>

          <AnchorTitle
            label="Algemeen"
            id="general"
          />
          <Input
            label="Naam"
            name="label"
          />
          <Input
            label="Actie banner"
            name="action"
            placeholder="Laat text zien voor speciale acties"
          />
          <Textarea
            label="Beschrijving"
            name="description"
          />


          <AnchorTitle
            label="Profiel"
            id="profile"
          />
          <Bool
            label="Openbaar Profiel: Wil je dat stands & trucks jou profiel kunnen bekijken (via onderstaande link) & boeken?"
            name="public"
          />
          <Slug
            label="Profiel URL / slug"
            text="Je mag de url voor je profiel maar een beperkt aantal keren aanpassen!"
            urlPostFix="locatie"
            name="slug"
            basedOnField="label"
          />


          <AnchorTitle
            label="Locatie"
            id="location"
          />
          <SelectBlock
            label="Deze locatie is:"
            name="types_ids"
            data={types}
          />
          <Location
            label="Klik op de kaart om de locatie aan te geven"
          />
          <br/>
          <br/>
          <Address
            label="Locatie Adres"
            text="Zichtbaar na een afgeronde boeking, zodat de stand/truck/Act naar deze locatie kan navigeren."
            name="address"
          />

          <AnchorTitle
            label="Afbeeldingen"
            id="images"
          />
          <Media
            label="Algemene/Vooraanzicht afbeelding"
            name="overview_media"
            width={1600}
            height={700}
            exampleImage={markedImage}
            size="banner"
          />

          <Media
            label="Andere afbeelding van locatie"
            name="other_media"
            width={900}
            size="normal_full_height"
          />

          <AnchorTitle
            label="Beschikbaarheid"
            id="availabilities"
          />
          <BusinessHour
            label="Openingstijden gebruiken"
            name="business_hour"
          />

          <Three
            label="Wat is de status van deze locatie?"
            name="available"
            labelYes="Elke dag beschikbaar"
            labelNo="(nog) niet beschikbaar (niet boekbaar en niet in zoekresultaten)"
            labelOther="Specifieke dag(en) ingeven"
          />
          <Availabilities
            label="Beschikbaarheid specifiek voor deze standplaats/grondplaats"
            name="availabilities"
            enabledBy={[{key: 'available', value: 2}]}
          />


          <AnchorTitle
            label="Standplaatsen (Grondplaatsen)"
            id="spots"
          />
          <Bool
            label="Hoeveel standplaatsen/grondplaatsen heeft deze locatie?"
            name="multi_spot"
            labelNo="1"
            labelYes="Meer dan 1"
          />
          <Bool
            label="Weergeven als lijst (standplaats/grondplaats per meter) of kaart (klikbare plattegrond)?"
            name="show_spots_as_list"
            labelNo="Kaart/plattegrond"
            labelYes="Lijst (prijs per x meter)"
            enabledBy={[{key: 'multi_spot', value: true}]}
            beforeSave={(model, save) => {
              if (!model.show_spots_as_list && model.spots.length > 1) {
                swal({
                  title: 'Let op!',
                  icon: 'warning',
                  text: 'Als je dit opslaat verlies je data van de standplaatskaart (de layout + prijzen van de standplaatsen). Als je dus nog geen kaart gemaakt hebt is het geen probleem!',
                  buttons: {
                    cancel: {
                      text: 'Annuleren',
                      value: false,
                      visible: true,
                      className: 'btn btn-color-dark',
                      closeModel: true,
                    },
                    confirm: {
                      text: 'Doorgaan?',
                      value: true,
                      visible: true,
                      className: 'btn btn-color-reen',
                      closeModel: true,
                    },
                  }
                }).then(result => {
                  save(result)
                })
              } else {
                save(true)
              }
            }}
          />
          <Input
            text="Per hoeveel meter kunnen stand/grondplaatsen geboekt worden? Prijs wordt per deze hoeveelheid berekend."
            type="meter"
            name="spots_in_list_length"
            min={0.1}
            max={50}
            enabledBy={[{key: 'multi_spot', value: true}, {key: 'show_spots_as_list', value: true}]}
          />

          <Input
            text="Maximaal aantal stand/grondplaatsen? (Stel je wil totaal 8 meter verhuren, en je wil dit per 2 meter stukken doen. Vul hier boven bij 'Per hoeveel meter...' dan 2 in, en hier 4.)"
            type="number"
            name="spot_count"
            min={1}
            max={1000}
            enabledBy={[{key: 'multi_spot', value: true}, {key: 'show_spots_as_list', value: true}]}
          />

          {/*<Checkbox*/}
          {/*  label="Elke spot heeft een 'voorkant' op de standplaatskaart/grondplaatskaart, aangegeven door een richting-pijl"*/}
          {/*  name="spot_map_show_spot_front"*/}
          {/*  enabledBy={[{key: 'multi_spot', value: true}, {key: 'show_spots_as_list', value: false}]}*/}
          {/*/>*/}
          {/*<Input*/}
          {/*  label="Marge tussen standplaatsen aanhouden voor verschillende stands binnen een standplaats groep"*/}
          {/*  text="Dwz, als standplaatsen direct tegen elkaar liggen wordt er een marge aangehouden tussen verschillende stands/trucks. BV: als je hier '2 meter' instelt, en er standplaatsen op de kaart dichter dan 2 meter tegen elkaar aan liggen, ze automatisch de zelfde boekings-status krijgen als de standplaats ernaast. Deze standplaatsen binnen deze marge zijn overigens wel beschikbaar voor de stand/truck die hier al staat."*/}
          {/*  name="booking_spot_margin"*/}
          {/*  type="meter"*/}
          {/*  enabledBy={[{key: 'multi_spot', value: true}, {key: 'show_spots_as_list', value: false}]}*/}
          {/*/>*/}
          <EditButton
            label={'Standplaatskaart & instellingen per standplaats'}
            link={'/user/locatie/%id/spots'}
            enabledBy={[{key: 'multi_spot', value: true},{key: 'show_spots_as_list', value: false}]}
            disabledOnChangeByKeys={['multi_spot', 'show_spots_as_list']}
          />


          <AnchorTitle
            label="Prijs"
            id="price"
          />
          <Price
            name="price"
          />


          <AnchorTitle
            label="Opties & Info"
            id="options"
          />
          <Options
            label="Betaalde extra's aanbieden"
            name="bookable_options"
            type="spot_group_option"
            text="Geef hier aan welke extra's je nog wil aanbieden tegen een vergoeding. Bijvoorbeeld verkoop van stroomaansluitingen, koffie, lunch"
            apiService={optionServiceSpotGroup}
            showPrice={true}
          />

          <Options
            label="Gevraagde Opties"
            name="bookable_options_requested"
            type="stand_option"
            text="Geef hier aan welke opties je verwacht van een stand/truck/act (Denk aan '16a stroom/verlengsnoer 10 meter')"
            apiService={optionServiceStand}
            showPrice={false}
          />

          <Options
            label="Belangrijke Informatie Regels & Voorzieningen"
            name="bookable_infos"
            type="spot_group_info"
            text="Geef hier aan welke belangrijke informatie / regels deze locatie allemaal heeft. Deze worden weergegeven op het profiel van deze locatie. (Denk aan gratis bijgelegen parkeergelegenheid of milieu-zones)"
            apiService={infoServiceSpotGroup}
            modelLabel={'informatie regel'}
            modelLabels={'informatie regels'}
            showPrice={false}
          />

          <Options
            label="Gevraagde Informatie Regels & Voorzieningen"
            name="bookable_infos_requested"
            type="stand_info"
            text="Geef hier aan welke eisen je aan de stand of trucks stelt, of welke zaken ze zelf zelf moeten regelen (Denk aan: 'electrische motor' of bepaalde vergunningen)"
            apiService={infoServiceStand}
            modelLabel={'informatie regel'}
            modelLabels={'informatie regels'}
            showPrice={false}
          />

          <AnchorTitle
            label="Boekingen"
            id="bookings"
          />
          <Checkbox
            label="Stands/Trucks toestaan om boekingsverzoeken te sturen ook als ze niet aan de (spot)-branche instellingen voldoen"
            name="booking_flexible_industry"
          />
          <Checkbox
            label="Stands/Trucks toestaan om te boeken zonder gekozen standplaats/spot"
            name="booking_without_spot"
          />
          <Textarea
            label="Boekingsvoorwaarden - zichtbaar bij het accepteren van de boeking"
            placeholder="Algemene (boekings)voorwaarden die gelden naast de standaardboekingsvoorwaarden van Standplaats.nl BV. In geval van overlap hebben de voorwaarden van Standplaats.nl BV voorrang."
            name="booking_conditions"
            rows={10}
          />
          <Textarea
            label="Boekingsinformatie - zichtbaar voor stands/trucks/acts nadat ze een boeking afgerond hebben op deze locatie"
            placeholder="Aanvangtijd/opbouwtijd, contactinformatie, rij-routes"
            name="booking_information"
            rows={8}
          />
        </Fields>
      </Form>
    </div>
  )
}

export default UserSpotGroupEdit
